<template>
<form @submit.prevent="submitForm">
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">{{ isUpdate ? 'Edit Hfm' : 'Add Hfm' }}</p>
        </header>
        <section class="modal-card-body">
            <b-notification type="is-danger" v-if="errorMessage" :closable="false">
                {{ errorMessage }}
            </b-notification>
            <b-field label="Code" horizontal>
                <b-input
                    type="text"
                    v-model="hfm.code"
                    required>
                </b-input>
            </b-field>
            <b-field label="Country" horizontal>
                <b-input
                    type="text"
                    v-model="hfm.country"
                    required>
                </b-input>
            </b-field>
            <b-field label="Company" horizontal>
                <b-input
                    type="text"
                    v-model="hfm.company"
                    required>
                </b-input>
            </b-field>
            <b-field horizontal>
                <b-checkbox v-model="hfm.isAuthorised">Is Authorised?</b-checkbox>
            </b-field>
        </section>
        <footer class="modal-card-foot">
            <button type="submit" class="button is-primary">{{ isUpdate ? 'Save' : 'Add' }}</button>
            <button  type="button" class="button" @click="onCancelAction">Cancel</button>
        </footer>
    </div>
</form>
</template>

<script>
import axios from '@/services/axios-auth-wrapper';

export default {
    name: 'HfmForm',
    props: {
        isUpdate: {
            type: Boolean,
            required: true
        },
        hfmToEdit: {
            type: Object,
            required: false
        }
    },
    data () {
        return {
            errorMessage: '',
            roles: [],
            hfm: {
                code: '',
                isAuthorised: false,
                country: '',
                company: ''
            }
        };
    },
    created () {
        if (this.hfmToEdit) {
            this.hfm = Object.assign(this.hfm, this.hfmToEdit);
        }
    },
    methods: {
        submitForm () {
            const url = process.env.VUE_APP_CONVERSABILITY_API_URL + '/api/hfmcode/';
            let action = this.isUpdate ? 'update' : 'create';

            axios.post(url + action, this.hfm)
                .then(response => {
                    this.$emit('submitEvent', response.data);
                    this.$parent.close();
                },
                error => {
                    if (error.response && error.response.data) {
                        this.errorMessage = error.response.data;
                    } else {
                        this.errorMessage = error.message;
                    }
                });
        },
        onCancelAction () {
            this.$parent.close();
        }
    }
};
</script>
